export const environment = {
  // Gyaani
     API_ROOT: process.env.REACT_APP_API_ROOT,
     FAQ_ROOT: process.env.REACT_APP_faqRoot,
     RECORD_ROOT: process.env.REACT_APP_recordRoot,
     MESSAGE_ROOT: process.env.REACT_APP_messageRoot,
     CATEUPLOAD_ROOT: process.env.REACT_APP_cateUploadRoot,
     EMAILUPLOAD_ROOT: process.env.REACT_APP_emailUploadRoot,
     USERUPLOAD_ROOT: process.env.REACT_APP_userUploadRoot,
     ASSETSUPLOAD_ROOT: process.env.REACT_APP_assetUploadRoot,
     LOCATION_ROOT: process.env.REACT_APP_locationRoot,
     DATA_ROOT: process.env.REACT_APP_dataRoot,
     KMMODULE_ROOT: process.env.REACT_APP_KmModuleRoot,
     QUEUE_ROOT: process.env.REACT_APP_queue,
     REPORT_ROOT: process.env.REACT_APP_reportRoot,
     MONITOR_ROOT: process.env.REACT_APP_monitorRoot,
  

     
   // AutoLearn
    AUTOLEARN_API_ROOT : process.env.REACT_APP_AUTOLEARN_API_ROOT,
    AUTOLEARN_FAQ_ROOT : process.env.REACT_APP_AUTOLEARN_APP_faqRoot,
    AUTOLEARN_MESSAGE_ROOT : process.env.REACT_APP_AUTOLEARN_APP_messageRoot,
    AUTOLEARN_RECORD_ROOT : process.env.REACT_APP_AUTOLEARN_APP_recordRoot,
    AUTOLEARN_CATE_UPLOAD_ROOT : process.env.REACT_APP_AUTOLEARN_APP_cateUploadRoot,
    AUTOLEARN_EMAIL_UPLOAD_ROOT : process.env.REACT_APP_AUTOLEARN_APP_emailUploadRoot,
    AUTOLEARN_USER_UPLOAD_ROOT : process.env.REACT_APP_AUTOLEARN_APP_userUploadRoot,
    AUTOLEARN_ASSET_UPLOAD_ROOT : process.env.REACT_APP_AUTOLEARN_APP_assetUploadRoot,
    AUTOLEARN_LOCATION_ROOT : process.env.REACT_APP_AUTOLEARN_APP_locationRoot,
    AUTOLEARN_DATA_ROOT : process.env.REACT_APP_AUTOLEARN_APP_dataRoot,
    AUTOLEARN_REPORT_ROOT : process.env.REACT_APP_AUTOLEARN_APP_reportRoot,
    AUTOLEARN_SOCKET_ROOT : process.env.REACT_APP_AUTOLEARN_APP_socketRoot,
    AUTOLEARN_MONITOR_ROOT : process.env.REACT_APP_AUTOLEARN_APP_monitorRoot,
    AUTOLEARN_AI_ROOT : process.env.REACT_APP_AUTOLEARN_APP_AIROOT,

   };
